import { render } from "./AgentAvgEarningsThreeChart.vue?vue&type=template&id=afd626e0&ts=true"
import script from "./AgentAvgEarningsThreeChart.vue?vue&type=script&lang=ts"
export * from "./AgentAvgEarningsThreeChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__